import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, User, UserCircle2, Menu, X, Plane, Building2, Palmtree, BookOpen, Tag, Users } from 'lucide-react';
import { useSettings } from '../store';
import GroupBookingModal from './GroupBookingModal';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [groupOpen, setGroupOpen] = useState(false);
  const settings = useSettings();
  const phoneRaw = (settings.phone || '+91-9650336344').replace(/\s+/g, '');
  const phoneTel = phoneRaw.startsWith('+') ? phoneRaw : `+${phoneRaw}`;
  return (
    <header className="absolute top-0 left-0 right-0 z-30">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 select-none" data-testid="header-logo">
          {settings.logo_url ? (
            <img
              src={settings.logo_url}
              alt="Travelsera"
              className="h-[50px] w-[180px] object-contain"
              style={{ maxHeight: 50, maxWidth: 180 }}
              onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.nextElementSibling && (e.currentTarget.nextElementSibling.style.display = 'block'); }}
            />
          ) : (
            <div className="text-white">
              <div className="text-[26px] font-extrabold leading-none tracking-tight">
                travel<span className="text-[#ffcc29]">sera</span>
              </div>
              <div className="text-[10px] italic opacity-90 -mt-0.5">{settings.tagline || 'journeys, redefined...'}</div>
            </div>
          )}
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8 text-white text-[15px] font-medium">
          <a href="#holidays" className="flex items-center gap-1.5 border-b-2 border-white pb-1 hover:opacity-90">
            <Palmtree size={18} /> Holidays
          </a>
          <button
            onClick={() => setGroupOpen(true)}
            data-testid="header-group-btn"
            className="flex items-center gap-1.5 hover:opacity-90 pb-1 border-b-2 border-transparent"
          >
            <Users size={18} /> Group Booking
            <span className="ml-0.5 text-[9px] uppercase tracking-widest bg-rose-500 text-white px-1.5 py-0.5 rounded">New</span>
          </button>
          <Link
            to="/offers"
            data-testid="nav-offers"
            className="relative flex items-center gap-1.5 bg-gradient-to-r from-[#ffcc29] to-[#ffb347] text-[#0a2a4a] font-semibold px-3 py-1 rounded-full shadow-sm hover:shadow-md hover:brightness-105 transition"
          >
            <Tag size={14} /> Offers
            <span className="relative flex h-2 w-2 ml-0.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-500 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-rose-600" />
            </span>
          </Link>
          <Link to="/blog" className="flex items-center gap-1.5 hover:opacity-90">
            <BookOpen size={18} /> Blog
          </Link>
          <a href={`tel:${phoneTel}`} className="flex items-center gap-1.5 hover:opacity-90">
            <Phone size={16} /> {phoneRaw}
          </a>
        </nav>

        {/* Auth buttons */}
        <div className="hidden lg:flex items-center gap-3">
          <button className="flex items-center gap-1.5 border border-white/70 text-white text-sm px-4 py-2 rounded-md hover:bg-white/10 transition">
            <User size={16} /> Login/SignUp
          </button>
        </div>

        {/* Mobile */}
        <button className="lg:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0d64a8] text-white px-5 py-4 space-y-3">
          <a href="#holidays" className="block">Holidays</a>
          <button
            onClick={() => { setGroupOpen(true); setOpen(false); }}
            data-testid="header-group-btn-mobile"
            className="flex items-center gap-2 w-full text-left"
          >
            <Users size={16}/> Group Booking
            <span className="text-[10px] bg-rose-500 text-white px-1.5 py-0.5 rounded uppercase tracking-widest">New</span>
          </button>
          <Link to="/offers" className="flex items-center gap-2 text-[#ffcc29] font-semibold">
            <Tag size={14}/> Offers
            <span className="text-[10px] bg-rose-500 text-white px-1.5 py-0.5 rounded uppercase tracking-widest">Hot</span>
          </Link>
          <Link to="/blog" className="block">Blog</Link>
          <a href={`tel:${phoneTel}`} className="block">{phoneRaw}</a>
          <div className="flex gap-2 pt-2">
            <button className="flex-1 border border-white/70 text-sm py-2 rounded-md">Login/SignUp</button>
          </div>
        </div>
      )}
      <GroupBookingModal open={groupOpen} onClose={() => setGroupOpen(false)} />
    </header>
  );
};

export default Header;
